var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmiciLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    fill: "currentColor",
    viewBox: "0 0 25.03968 25.016592",
    id: "svg362",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs359"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-39.245495,-48.511179)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 46.037419,50.16082 a 10.877021,10.877021 0 1 1 9.694333,19.3675 10.877021,10.877021 0 0 0 -9.694333,-19.3675 z",
    id: "path115",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 57.483294,71.867237 A 10.879667,10.879667 0 1 1 47.791607,52.497091 10.877021,10.877021 0 0 0 57.483294,71.867237 Z",
    id: "path117",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 40.872753,66.718445 A 10.768542,10.768542 0 0 1 39.245565,60.98757 10.908771,10.908771 0 0 1 60.306398,57.058508 10.895542,10.895542 0 0 0 40.872753,66.718445 Z",
    id: "path119",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 62.650606,55.306966 A 10.863792,10.863792 0 0 1 53.39019,71.901632 10.908771,10.908771 0 0 1 43.214315,64.972195 10.898187,10.898187 0 0 0 62.650606,55.306966 Z",
    id: "path121",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 51.019523,57.30457 q 1.137708,2.259542 -0.116417,3.720042 c -0.759354,1.383771 -1.833562,1.693333 -2.950104,1.852083 -1.44727,-0.179917 -2.592916,0.06879 -3.07975,1.267354 q -0.357187,1.759479 1.25148,2.286 c 0.841375,0.227542 1.640416,0.264584 2.135187,-1.076854 0.550333,-1.254125 1.145646,-2.481792 3.087687,-2.801937 1.169459,-0.105834 2.307167,-0.05027 3.304646,0.79375 0.41275,0.264583 0.851959,1.502833 1.447271,2.397125 0.764646,0.481541 1.550458,0.79375 2.500313,0.01852 a 2.38125,2.38125 0 0 0 0.24077,-2.307166 c -0.608541,-1.058334 -1.441979,-1.058334 -2.38125,-0.592667 -1.309687,0.15875 -2.595562,-0.309562 -3.831166,-2.159 -0.508,-0.751417 -0.529167,-1.748896 -0.08467,-3.000375 0.0979,-0.650875 0.494771,-1.288521 0.931333,-1.926166 q 0.336021,-1.838855 -1.404937,-2.243667 -1.362605,-0.330729 -2.100792,1.479021 -0.185208,1.277937 1.058333,2.307166 z",
    id: "path123",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0.264583
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmiciLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/amici-logo.102d4dd33830fdb3dc49b8c90379a7bb.svg";